<div class="root" (mouseup)="vm.clearDrags($event)">
  <header>
    <ng-template *ngIf="isVOD; then VODHeader; else liveHeader"></ng-template>
    <ng-template #VODHeader>
      <evrideo-content-control-studio-vod-header
        *ngIf="headerReady"
        [title]="manager.mediaName"
        [vm]="vodVM"
      ></evrideo-content-control-studio-vod-header
    ></ng-template>
    <ng-template #liveHeader>
      <evrideo-content-control-studio-live-header
        *ngIf="headerReady"
        [title]="manager.mediaName"
        [vm]="liveVM"
      ></evrideo-content-control-studio-live-header>
    </ng-template>
  </header>
  <main>
    <div class="events">
      <evrideo-content-control-studio-events
        [events]="manager.editingDirectives"
        [mediaId]="mediaId"
        [channelUid]="channelUid"
        [contentControlManager]="manager"
        [view-model]="vm"
        [selected-event-id]="manager.selectedSegment?.id || -1"
        [one-frame]="timelineRef?.oneFrameSecs ?? 0"
      ></evrideo-content-control-studio-events>
    </div>

    <div class="video-player">
      <h2 #loadingText style="display: flex; vertical-align: center">
        Loading video....
      </h2>
      <div #videoContainer class="player" style="display: none">
        <video
          #video
          width="1280"
          height="720"
          style="display: none"
          crossorigin="anonymous"
        ></video>
        <div class="canvas-container">
          <canvas #canvas></canvas>
          <canvas #drawingCanvas></canvas>
        </div>
        <div class="audio-subtitle">
          <evrideo-content-control-studio-dropdown
            [options]="vm?.audioOptions ?? []"
            [selectedOption]="vm?.selectedAudioOption"
            (selectedChanged)="vm.onAudioChange($event)"
          >
            <div
              class="icon"
              [attr.title]="
                vm?.isAudioForcedMuted || vm?.isAudioMuted
                  ? 'Unmute Audio'
                  : 'Mute Audio'
              "
              (click)="
                (vm?.isAudioForcedMuted == false && vm.mute($event)) ||
                  (vm?.isAudioForcedMuted && vm.unmute($event))
              "
            >
              <evrideo-head-phone
                style="
                  width: 11px;
                  height: 11px;
                  display: flex;
                  align-items: center;
                "
                [overrideStyle]="{ fill: 'white' }"
                [disabled]="vm?.isAudioForcedMuted || vm?.isAudioMuted"
                class="cursor-pointer"
              ></evrideo-head-phone>
            </div>
            <span class="text">AUDIO {{ vm?.selectedAudioOption }}</span>
          </evrideo-content-control-studio-dropdown>
          <evrideo-content-control-studio-dropdown
            [options]="vm?.subtitleOptions ?? []"
            [selected-options]="vm?.selectedSubtitleOptions ?? []"
            (multi-selection-changed)="vm.onSubtitleChange($event)"
            [is-multi]="true"
          >
            <span class="text"
              >SUBS
              {{
                vm?.selectedSubtitleOptions?.length == 1
                  ? vm?.selectedSubtitleOptions[0]
                  : "MANY"
              }}</span
            >
          </evrideo-content-control-studio-dropdown>
        </div>
      </div>
      <div class="controls">
        <div class="ot-et">
          <evrideo-tot-sliding-toggle
            [hidden]="vm?.isFitSegment"
            [this]="'OT'"
            [that]="'ET'"
            [default]="'this'"
            (its)="vm.onTimelineModeChange($event)"
          ></evrideo-tot-sliding-toggle>
        </div>
        <div class="segments">
          <div class="control-button" title="Mark In" (click)="vm.markIn()">
            <evrideo-mark-in-icon></evrideo-mark-in-icon>
          </div>
          <div class="control-button" title="Mark Out" (click)="vm.markOut()">
            <evrideo-mark-out-icon></evrideo-mark-out-icon>
          </div>
        </div>
        <div class="video-controls">
          <div class="control-button" title="Go To In" (click)="vm.goToIn()">
            <evrideo-skip-backward-icon></evrideo-skip-backward-icon>
          </div>
          <div
            class="control-button"
            title="Step Back 1 Frame"
            (click)="vm.frameDown(1)"
          >
            <evrideo-step-backward-icon></evrideo-step-backward-icon>
          </div>
          <div
            class="control-button"
            (click)="vm.pause()"
            title="Pause"
          >
            <evrideo-pause-icon></evrideo-pause-icon>
          </div>
          <div
            class="control-button"
            (click)="vm.play()"
            title="Play"
          >
            <evrideo-play-icon></evrideo-play-icon>
          </div>
          <div
            class="control-button"
            title="Step Forward 1 Frame"
            (click)="vm.frameUp(1)"
          >
            <evrideo-step-forward-icon></evrideo-step-forward-icon>
          </div>
          <div class="control-button" title="Go To Out" (click)="vm.goToOut()">
            <evrideo-skip-forward-icon></evrideo-skip-forward-icon>
          </div>
          <div
            *ngIf="isLive"
            class="control-button"
            title="Go To Live"
            (click)="vm.moveToLiveEdge()"
          >
            <span>live</span>
          </div>
        </div>
        <div class="zoom-controls">
          <div
            class="control-button"
            title="Zoom Out"
            (click)="vm.timelineZoom(1)"
          >
            <evrideo-zoom-out-icon></evrideo-zoom-out-icon>
          </div>
          <div
            class="control-button"
            title="Zoom In"
            (click)="isLive ? liveVM.timelineZoomLive() : vm.timelineZoom(-1)"
          >
            <evrideo-zoom-in-icon></evrideo-zoom-in-icon>
          </div>
          <div
            class="control-button"
            title="Fit"
            (click)="vm.timelineZoomFitVideo()"
          >
            <span>fit</span>
          </div>
          <div
            class="control-button"
            title="Fit Segment"
            (click)="vm.timelineZoomFitSegment()"
          >
            <span>fit seg</span>
          </div>
        </div>
      </div>
      <evrideo-content-control-studio-vod-timeline
        *ngIf="isVOD; else liveTimeline"
        #timelineComponent
        [studio-view-model]="vodVM"
      ></evrideo-content-control-studio-vod-timeline>
      <ng-template #liveTimeline>
        <evrideo-content-control-studio-live-timeline-v2
          #timelineComponent
          [studio-view-model]="liveVM"
        ></evrideo-content-control-studio-live-timeline-v2>
      </ng-template>
    </div>

    <div class="actions">
      <evrideo-content-control-studio-actions
        [is-live]="isLive"
        [is-subtitles-available]="(vm?.subtitleOptions?.length ?? 0) > 0"
        (on-button-clicked)="vm.actionButtonClicked($event)"
        [selected-segment]="manager.selectedSegment"
        (on-selected-segment-changes)="vm.segmentToEvent($event)"
        (on-video-clip-add)="vm.onVideoClipAdd($event)"
        [timeline-mode]="vm?.timelineMode"
      ></evrideo-content-control-studio-actions>
    </div>
  </main>
</div>
<evrideo-hls-debug-panel
  *ngIf="isLive && liveVM?.showDebugPanel"
  [liveTimeline]="$any(timelineRef)"
  [liveVM]="liveVM"
  (closed)="liveVM.showDebugPanel = false"
></evrideo-hls-debug-panel>
<evrideo-vod-debug-panel
  *ngIf="isVOD && vm?.showDebugPanel"
  [vodTimeline]="$any(timelineRef)"
  [vodVM]="vodVM"
  (closed)="vm.showDebugPanel = false"
></evrideo-vod-debug-panel>
<ng-container #dialogContainer></ng-container>
